import { useRef, useState } from 'react'

export default function MainSkillCheckbox (props) {
  const { main, skill_id: skillId } = props
  const [mainSkillState, setMainSkillState] = useState(!!main)
  const containerRef = useRef(null)

  const _setMainSkill = () => {
    const form = $(containerRef.current).parents('form')
    setMainSkillState(!mainSkillState)
    $('button[type="submit"]', form).prop('disabled', false)
  }

  return (
    <div className='main-skill' ref={containerRef}>
      <input
        type='hidden'
        name={`main[${skillId}]`}
        value={mainSkillState ? 1 : 0}
      />
      <label className='checkbox'>
        <input
          type='checkbox'
          checked={mainSkillState}
          onChange={_setMainSkill}
        />
        <span className='box'> </span>
      </label>
    </div>
  )
}
